export const configRefreshRoutes = [
  '/',
  '/tenant-services',
  '/contracts',
  '/contract-overview',
  '/documents',
  '/repairs-and-inquiries',
  '/inbox',
  '/consultations'
]